<template>
  <card>
    <language-list
      v-if="$store.state.user.is_root"
      v-model="params['locale']"
      :isAll="true"
      @input="params['page'] = 1"
    />
    <list
      v-if="$store.state.user.is_root"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :params="params"
      :setLink="setLink"
      :filters="filters"
      :openItem="true"
      :fields="fields"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      staticFilters: [
        {
          title: "Тип",
          key: "type",
          default: "material-theme",
          items: [
            {
              id: "material-theme",
              value: "material-theme",
              name: "Все типы",
            },
            {
              id: "material",
              value: "material",
              name: "Доп. материал",
            },
            {
              id: "theme",
              value: "theme",
              name: "Темы",
            },
          ],
        },
      ],
      val: [],
      params: {
        type: "material-theme",
      },
      modalCreate: "lessonplan",

      filters: [
        {
          key: "course",
          title: "Номер Класса",
        },
        {
          key: "author",
          title: "Автор",
        },
        {
          key: "discipline",
          title: "Дисциплина",
        },
      ],

      fields: [
        {
          label: "Тип",
          key: "type",
          type: "static_radio",
          default: "theme",
          items: [
            { id: "theme", title: "Тема" },
            { id: "material", title: "Доп. материал" },
          ],
        },

        {
          col: "col-12 col-md-8",
          key: "name",
          label: "Название темы",
          type: "field",
          textType: "text",
        },

        {
          label: "Предмет",
          key: "discipline",
          type: "select",
          selectKey: "title",
          modal: "discipline",
          prefix: "discipline_lessonplan",
        },
        {
          label: "Автор",
          key: "author",
          type: "select",
          selectKey: "title",
          modal: "author",
          prefix: "author",
        },
        {
          col: "col-12 col-md-6",
          key: "locale",
          label: "Локализация контента",
          type: "locale",
          textType: "text",
        },
        {
          col: "col-12 col-md-6",
          label: "Для классов",
          key: "course_id",
          type: "course",
        },
        {
          selectKey: "position",
          label: "Для других классов",
          key: "courses",
          type: "selects",
          modal: "coursesModal",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_theme",
      itemLink: "lessonplans",
      setLink: "lessonplans",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
        },
        {
          key: "type_display",
          title: "Тип",
          checkbox: false,
        },
        {
          key: "name",
          title: "Название темы",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "locale",
          title: "Язык",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "discipline",
          title: "Предмет",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          object: "title",
        },
        {
          key: "author",
          title: "Автор",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          object: "title",
        },
        {
          key: "course",
          object: "title",
          title: "Класс",
          checkbox: false,
          full: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "created_at",
          title: "Создан",
          sortBy: "created_at",
          dateTimeFormat: true,
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
